import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { api } from "@/lib/api";
import { IuniFlower } from "@/components/landing/IuniFlower";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

// Handles the Emergent Google OAuth return: /admin#session_id=...
function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then((res) => navigate("/admin", { state: { user: res.data }, replace: true }))
      .catch(() => navigate("/admin", { replace: true }));
  }, [navigate]);

  return (
    <div
      className="min-h-screen bg-[#F5F5F7] flex flex-col items-center justify-center gap-4"
      data-testid="auth-callback-loading"
    >
      <IuniFlower size={40} />
      <p className="text-sm text-gray-400">Accesso in corso...</p>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Synchronous check during render: process a fresh session_id BEFORE any auth checks
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
